module.exports = __webpack_public_path__ + "static/media/ident-bg.3d03eb17.png";